import { forwardRef } from "react";

import {
  DISCOUNT_TAG_CLASS_NAME,
  DISCOUNT_TAG_DEFAULTS,
  DISCOUNT_TAG_ICON_CLASS_NAME,
  type TDiscountTagProps,
} from "@/ui/components/data-display/DiscountTag/DiscountTag.config";
import { Container } from "@/ui/components/layout/Container";
import { Icon } from "@/ui/components/primitives/Icon";
import { TextBody } from "@/ui/components/typography/TextBody";
import { cn } from "@/ui/lib/utils";

export const DiscountTag = forwardRef<HTMLDivElement, TDiscountTagProps>(
  (
    {
      className,
      children,
      icon = DISCOUNT_TAG_DEFAULTS.icon,
      ...props
    },
    ref,
  ) => (
    <Container
      {...props}
      ref={ref}
      tag="div"
      data-component="DiscountTag"
      className={cn(
        DISCOUNT_TAG_CLASS_NAME,
        className,
      )}
    >
      { icon ? (
        <Icon
          icon={icon}
          aria-hidden="true"
          className={DISCOUNT_TAG_ICON_CLASS_NAME}
        />
      ) : null }
      <TextBody
        tag="span"
        size={3}
        color="inherit"
        isResponsive={false}
      >
        { children }
      </TextBody>
    </Container>
  ),
);

DiscountTag.displayName = "DiscountTag";
